import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string'

import Container from '@material-ui/core/Container';
import { getOpportunityByIdExterno } from '../../serviceAPI/opportunity/getOpportunityByIdExterno';
import history from '../../history';
import CardVaga from './components/CardVaga';

function DetalhesVagaExterno(props) {
    const dispatch = useDispatch();
    const values = queryString.parse(props.location.search)
    const id = values.id

    const vaga = useSelector(state => state.opportunity.opportunity)
    const vagaNotFound = useSelector(state => state.opportunity.opportunityNotFound)
    const token = localStorage.getItem(process.env.REACT_APP_TOKENUSER)

    React.useEffect(() => {
        if (id != null && id > 0) {
            getOpportunityByIdExterno(id, dispatch);
        } else {
            history.push('not-found');
        }
    }, [id]);

    React.useEffect(() => {
        if (vagaNotFound) {
            history.push('not-found')
        }
    }, [vagaNotFound]);

    React.useEffect(() => {
        if (token) {
            history.push(`detalhes-vaga?id=${id}`)
        }
    }, [token]);

    return (
        <div>
            <Container component="main" maxWidth="md">
                <CardVaga vaga={vaga} />
            </Container>
        </div>
    )
}

export default DetalhesVagaExterno;